import styled from 'styled-components';

export const PartnerAdvMainWrap = styled.div(
    props => `
        width:100%;
        display: flex;
        padding: ${props.theme.spacing.large.l40} 0;
        background-image: linear-gradient(359deg, #fbfbfb 98%, rgba(245, 245, 245, 0.09) 9%);
        
        @media only screen and (min-width:320px) and (max-width: 991px){
            padding-top: ${props.theme.spacing.large.l20};
        }
    `
);

export const PartnerAdvOuterWrap = styled.div(
    props => `
        width:100%;
        display: flex;
        flex-direction: column;
        margin: 0 auto;
        max-width:85%;

        @media only screen and (min-width:320px) and (max-width: 991px){
            max-width:100%;
        }

        @media only screen and (min-width:992px) and (max-width: 1300px){
            max-width:100%;
        }
    `
);

export const PartnerAdvHeadWrap = styled.div(
    props => `
        width:100%;
        display: flex;
        align-items: center;
        flex-direction: column;
        padding-bottom: ${props.theme.spacing.large.l40};

        @media only screen and (min-width:320px) and (max-width: 991px){
            padding: 0 ${props.theme.spacing.large.l25} ${props.theme.spacing.large.l15};
            align-items: flex-start;
        }
    `
);

export const PartnerAdvHeadText = styled.h2(
    props => `
        font-size: ${props.theme.font.large.font35};
        color: ${props.theme.colors.black.base1};
        font-weight: ${props.theme.font.fontWeight.black};

        @media only screen and (min-width:320px) and (max-width: 991px){
            font-size: ${props.theme.font.large.font18};
        }
    `
);

export const PartnerAdvSubText = styled.p(
    props => `
        font-size: ${props.theme.font.large.font18};
        color: ${props.theme.colors.grey.dark3};
        line-height: 1.33;

        @media only screen and (min-width:320px) and (max-width: 991px){
            font-size: ${props.theme.font.base};
        }
    `
)

export const PartnerAdvInnerWrap = styled.div(
    props => `
        width:100%;
        display: flex;
        align-items: center;
    `
);

export const PartnerAdvBannerWrap = styled.div(
    props => `
        width:50%;
        display: flex;
        align-items: flex-end;
        justify-content: center;
        height: 51.5rem;

        @media only screen and (min-width:320px) and (max-width:991px){
            display: none;
        }

        
    `
);

export const PartnerAdvBannerImg = styled.img(
    props => `
        width: 56.5rem;
        height: 48.7rem;
        @media only screen and (min-width:992px) and (max-width: 1300px){
            width:44.5rem;
            height: 42.7rem;
        }
    `
);

export const PartnerAdvInfoWrap = styled.div(
    props => `
        width:50%;
        display: flex;
        flex-direction: column;

        @media only screen and (min-width:320px) and (max-width: 991px){
            width:100%;
            padding: ${props.theme.spacing.large.l15};
        }
    `
);

export const PartnerAdvInfoOuterWrap = styled.div(
    props => `
        width:100%;
        display: flex;
        align-items: center;
        padding: ${props.theme.spacing.large.l15};
        margin-bottom: ${props.theme.spacing.large.l25};

        @media only screen and (min-width:320px) and (max-width: 991px){
            padding: ${props.theme.spacing.base};
            margin-bottom: ${props.theme.spacing.base};
        }
    `
);

export const PartnerAdvInfoIconWrap = styled.div(
    props => `
        width: 4.2rem;
        height: 4.2rem;
        display: flex;
        margin-right: ${props.theme.spacing.large.l15};
    `
);

export const PartnerAdvInfoTextWrap = styled.div(
    props => `
        display: flex;
        width:80%;
        flex-wrap: wrap;
    `
);

export const PartnerAdvInfoText = styled.p(
    props => `
        font-size: ${props.theme.font.large.font20};
        color: ${props.theme.colors.green.dark1};
        font-weight: ${props.theme.font.fontWeight.bold};
        line-height: 1.3;

        @media only screen and (min-width:320px) and (max-width: 991px){
            font-size: ${props.theme.font.large.font14};
        }
    `
)